import { fetchDefData } from "@/apis";

export const PermissionTableCSModule = {
  namespaced : true,
  
  state() {
    return {
      domains: null,
      apps: null,
      selectedDomains: null,
      selectedApps: null,
      MapPermissions: {},  
      
    }
  },
  getters: {
    defIDs(state, getters, rootState, rootGetters){
      const domainsIDs = (state.domains ?? []).map(d => d.id)
      const appsIDs = (state.apps ?? []).map(a => a.id)
      return [...domainsIDs, ...appsIDs]
    },

  },
  mutations: {
    setDomains(state, payload){
      state.domains = payload
    },
    setApps(state, payload){
      state.apps = payload
    },
    setSelectedDomains(state, selectedDefIDs){
      const selectedDefDomains = []
      const selectedDefApps = []
      if(!!selectedDefIDs){
        selectedDefIDs.forEach(element => {
          const selectedDomain = state.domains.find(d => d.id === element)
          if(!!selectedDomain){
            selectedDefDomains.push(selectedDomain)
          }else {
            const selectedApp = state.apps.find(a => a.id === element)
            if(!!selectedApp){
              selectedDefApps.push(selectedApp)
            }
          }
        });
      }

      state.selectedDomains = selectedDefDomains
      state.selectedApps = selectedDefApps
    },
    addOrReplaceMapPermission(state, { key, value }){
        state.MapPermissions = { ...state.MapPermissions, [key]: value }
    },
    removeMapPermissions(state, key){
      const cloneMapPermissions = Object.assign({}, state.MapPermissions)
      delete cloneMapPermissions[key]
      state.MapPermissions = cloneMapPermissions
    },
    dropMapPermissions(state){
      state.MapPermissions = {}
    }
  },
  actions: {

    async getDefData({commit,dispatch,state, rootGetters, rootState}, payload){

        const data =  await fetchDefData('Root', {
          resources: false, routes: false
        })
        const domains = data.tiers.flatMap(t => t.domains || [])
        const apps =  data.apps || []
        commit('setDomains', domains )
        commit('setApps', apps )        
    },

    /**
     * @description
     * @returns {Promise<void>}
     */
    async findActiveDefDomainsAndApps({commit,dispatch,state, rootGetters, rootState}, payload){
      const selectedDefIDs = new Set()
      const mapPermissions = state.MapPermissions
      for (const key in mapPermissions){
        const selectedDefDomainIDs = state.domains.find(domain =>  String(key).includes(domain.id))?.id  
        const selectedDefAppsIDs = state.apps.find(app =>  String(key).includes(app.id))?.id 

        if(selectedDefDomainIDs) selectedDefIDs.add(selectedDefDomainIDs)
        if(selectedDefAppsIDs) selectedDefIDs.add(selectedDefAppsIDs)  
      }

      commit('setSelectedDomains',Array.from(selectedDefIDs))
      
    },

    async resetState({commit,state, rootGetters, rootState}, payload){
        commit('dropMapPermissions' )
        commit('setSelectedDomains', null)
        commit('setDomains', null )
        commit('setApps', null ) 
      
    }
  }
}


